function updateHelpScoutBeacon(currentPath = '/'): void {
  if (window.Beacon) {
    window.Beacon('event', {
      type: 'page-viewed',
      url: document.location.href,
      title: `${document.title}: ${currentPath}`,
    })
    window.Beacon('suggest')
  }
}

const isObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null

function getBeaconStyle(): string {
  if (!window.Beacon) return ''

  const info: unknown = window.Beacon('info')
  if (!isObject(info) || !isObject(info.config)) return ''
  if (!isObject(info.config.display)) return ''

  return typeof info.config.display.style === 'string'
    ? info.config.display.style
    : ''
}

function isBeaconVisible(): boolean {
  return getBeaconStyle() !== 'manual'
}

export const HelpScoutBeacon = {
  updateHelpScoutBeacon,
  getBeaconStyle,
  isBeaconVisible,
}
